module.exports = __webpack_public_path__ + "static/img/code.fd8dce2.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/code.png
// module id = NsB3
// module chunks = 4